import { useCallback, useEffect, useState } from "react";
import { chatWebSocketManager } from "../websocket";
import type { ChatConnectionStatus } from "../websocket";

export function useActiveWebSocketConnection(chatId: string | undefined) {
  const [connectionStatus, setConnectionStatus] =
    useState<ChatConnectionStatus>("disconnected");

  const connection = chatId ? chatWebSocketManager.setActiveChat(chatId) : null;

  const handleStatusChange = useCallback((status: ChatConnectionStatus) => {
    setConnectionStatus(status);
  }, []);

  useEffect(() => {
    if (!connection) {
      return;
    }

    connection.addStatusHandler(handleStatusChange);

    return () => {
      connection.removeStatusHandler(handleStatusChange);
    };
  }, [connection, handleStatusChange]);

  const connect = useCallback(async () => {
    if (!connection) {
      return;
    }

    try {
      await connection.connect();
    } catch (error) {
      // Connection errors will be handled through status changes
      // and by the messaging hook via the messageStore
    }
  }, [connection]);

  return {
    connection,
    status: connectionStatus,
    connect,
  };
}
